import React, { useState, useEffect } from 'react';
import './ProgressiveImage.css';

const ProgressiveImage = ({ 
  src, 
  placeholder, 
  alt, 
  className = '', 
  style = {},
  asBackground = false,
  children,
  ...props 
}) => {
  const [imageSrc, setImageSrc] = useState(placeholder || src);
  const [imageRef, setImageRef] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let img = new Image();
    img.src = src;
    img.onload = () => {
      setImageSrc(src);
      setIsLoaded(true);
    };
    
    return () => {
      img.onload = null;
    };
  }, [src]);

  if (asBackground) {
    return (
      <div 
        className={`progressive-image-background ${className} ${isLoaded ? 'loaded' : ''}`}
        style={{
          backgroundImage: `url(${imageSrc})`,
          ...style
        }}
        {...props}
      >
        {children}
      </div>
    );
  }

  return (
    <img
      ref={setImageRef}
      src={imageSrc}
      alt={alt}
      className={`progressive-image ${className} ${isLoaded ? 'loaded' : ''}`}
      style={style}
      {...props}
    />
  );
};

export default ProgressiveImage;